import { User } from '../store/auth/types';

/**
 * Checks if CRM feature is enabled for a user.
 * CRM is enabled if the CRM feature flag is true AND DISABLE_CRM is not true.
 * 
 * @param user - The user object to check, or undefined/null
 * @returns true if CRM is enabled, false otherwise
 */
export const hasCRM = (user: User | null | undefined): boolean => {
  if (!user?.features) {
    return false;
  }
  return !!(user.features.CRM && !user.features.DISABLE_CRM);
};

